﻿module SafeStack.Client.List

let private toLower (s: string) =
    s.ToLower()

let sortStringsByCI getter =
    List.sortBy (getter >> toLower)